import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSignatureImageIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 20,
			fill: "#F0EEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.2633 11.5992L13.0533 20.2892C12.7433 20.6192 12.4433 21.2692 12.3833 21.7192L12.0133 24.9592C11.8833 26.1292 12.7233 26.9292 13.8833 26.7292L17.1033 26.1792C17.5533 26.0992 18.1833 25.7692 18.4933 25.4292L26.7033 16.7392C28.1233 15.2392 28.7633 13.5292 26.5533 11.4392C24.3533 9.36924 22.6833 10.0992 21.2633 11.5992Z",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.8906 13.0508C20.3206 15.8108 22.5606 17.9208 25.3406 18.2008",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 30.0008C11 30.0008 15 33.5006 20 30.0008C25 26.501 29 30.0008 29 30.0008",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgSignatureImageIcon;
